import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Importaciones de módulos.
import { ProductsModule } from './products/products.module';
import { ActivationModule } from './activation/activation.module';
import { ComponentsModule } from '../components/components.module';
import { LoginModule } from './login/login.module';
import { RouterModule } from '@angular/router';
import { SettingsModule } from './settings/settings.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    LoginModule,
    ProductsModule,
    ActivationModule,
    SettingsModule,
  ],
})
export class PagesModule {}
